import React from 'react';
// Components
import ContactForm from '../forms/ContactForm';
// Constants
import {
  CompanyPhoneNumber,
  CompanyEmailAddress,
  INSTAGRAM_URL,
  TWITTER_URL,
  TIKTOK_URL,
} from '../../utils/Constants';
// Icons
import { FiPhone, FiMail } from 'react-icons/fi';
import { MdTextsms } from 'react-icons/md';
import { FaInstagram } from 'react-icons/fa';
import { FaXTwitter, FaTiktok } from 'react-icons/fa6';
import SocialMediaCtaComponent from '../socialMedia/SocialMediaCtaComponent';
// Images
import SissyBannerImage from '../../assets/images/banners/lady-cinder-dominatrix-in-la-banner-sissies.webp';
import VoteForMeNowCta from '../cta/VoteForMeNowCta';

function ContactPageMainContainer() {
  return (
    <main
      role='main'
      className='grid w-full min-h-screen bg-colour2 text-colour1 font-poppins'
    >
      <section className='grid w-full'>
        <div className='grid lg:grid-cols-2 px-6 sm:px-8 md:px-10 lg:container lg:mx-auto py-10 gap-x-12 gap-y-10'>
          {/* LEFT: Intro + contact info */}
          <article
            className='grid gap-6 bg-colour5/10 backdrop-blur-sm p-6 lg:p-8 rounded-2xl shadow-cardShadowBold'
            aria-labelledby='contact-title'
            itemScope
            itemType='https://schema.org/ContactPage'
          >
            <div className='grid gap-3'>
              <h3
                id='contact-title'
                className='text-2xl md:text-3xl font-semibold neon_text_duo_magenta_violet'
              >
                Speak to the Fire
              </h3>
              <div className='neon_line' />
              <div className='grid gap-4 text-base md:text-lg leading-relaxed'>
                <p>
                  I am <strong>Lady Cinder</strong> — neon-gothic dominatrix,
                  circus freak, and fire-eater. Use the methods below or the
                  booking form to request
                  <em> hypnosis</em>, <em>sensual sadism</em>, and{' '}
                  <em>indoctrination rituals</em>, in person or online.
                </p>
                <p>Be precise. Be polite. I answer devotion with heat.</p>
              </div>
            </div>

            {/* Contact methods */}
            <section
              className='grid gap-4'
              aria-labelledby='contact-methods-title'
              itemProp='mainContentOfPage'
            >
              <h4
                id='contact-methods-title'
                className='font-semibold text-colour1/90'
              >
                Contact methods
              </h4>

              <ul className='grid grid-cols-1 sm:grid-cols-2 gap-4'>
                {/* Call */}
                <li>
                  <a
                    href={`tel:${CompanyPhoneNumber}`}
                    className='grid grid-cols-[auto_1fr] items-center gap-4 px-5 py-4 rounded-2xl bg-colour3/10 hover:bg-colour3/20 transition-colors focus:outline-none focus-visible:ring-2 focus-visible:ring-colour6'
                    aria-label={`Call ${CompanyPhoneNumber}`}
                    itemProp='telephone'
                  >
                    <FiPhone
                      className='text-colour6 text-3xl'
                      aria-hidden='true'
                    />
                    <span className='text-colour1 text-lg font-extrabold'>
                      Call: {CompanyPhoneNumber}
                    </span>
                  </a>
                </li>

                {/* Text */}
                <li>
                  <a
                    href={`sms:${CompanyPhoneNumber}`}
                    className='grid grid-cols-[auto_1fr] items-center gap-4 px-5 py-4 rounded-2xl bg-colour3/10 hover:bg-colour3/20 transition-colors focus:outline-none focus-visible:ring-2 focus-visible:ring-colour6'
                    aria-label='Send a text message'
                  >
                    <MdTextsms
                      className='text-colour6 text-3xl'
                      aria-hidden='true'
                    />
                    <span className='text-colour1 text-lg font-extrabold'>
                      Text
                    </span>
                  </a>
                </li>

                {/* Email */}
                <li className='sm:col-span-2'>
                  <a
                    href={`mailto:${CompanyEmailAddress}`}
                    className='grid grid-cols-[auto_1fr] items-center gap-4 px-5 py-4 rounded-2xl bg-colour3/10 hover:bg-colour3/20 transition-colors focus:outline-none focus-visible:ring-2 focus-visible:ring-colour6'
                    aria-label={`Email ${CompanyEmailAddress}`}
                    itemProp='email'
                  >
                    <FiMail
                      className='text-colour6 text-3xl'
                      aria-hidden='true'
                    />
                    <span className='text-colour1 text-lg font-extrabold break-words'>
                      {CompanyEmailAddress}
                    </span>
                  </a>
                </li>

                {/* Socials */}
                <li className='sm:col-span-2'>
                  <div className='grid gap-3 px-5 py-4 rounded-2xl bg-colour3/10'>
                    <span className='text-colour1 text-base md:text-lg font-semibold'>
                      Follow Me
                    </span>
                    <div className='neon_line' />
                    <nav
                      aria-label='Lady Cinder social media'
                      className='grid grid-flow-col auto-cols-max gap-4'
                    >
                      {/* Instagram */}
                      <a
                        href={INSTAGRAM_URL}
                        target='_blank'
                        rel='noopener noreferrer'
                        aria-label='Lady Cinder on Instagram'
                        title='Instagram'
                        className='grid p-2 rounded-xl hover:bg-colour3/20 focus:outline-none focus-visible:ring-2 focus-visible:ring-colour6'
                      >
                        <FaInstagram
                          className='text-colour7 text-2xl'
                          aria-hidden='true'
                        />
                      </a>

                      {/* X / Twitter */}
                      <a
                        href={TWITTER_URL}
                        target='_blank'
                        rel='noopener noreferrer'
                        aria-label='Lady Cinder on X (Twitter)'
                        title='X (Twitter)'
                        className='grid p-2 rounded-xl hover:bg-colour3/20 focus:outline-none focus-visible:ring-2 focus-visible:ring-colour6'
                      >
                        <FaXTwitter
                          className='text-colour7 text-2xl'
                          aria-hidden='true'
                        />
                      </a>

                      {/* TikTok */}
                      <a
                        href={TIKTOK_URL}
                        target='_blank'
                        rel='noopener noreferrer'
                        aria-label='Lady Cinder on TikTok'
                        title='TikTok'
                        className='grid p-2 rounded-xl hover:bg-colour3/20 focus:outline-none focus-visible:ring-2 focus-visible:ring-colour6'
                      >
                        <FaTiktok
                          className='text-colour7 text-2xl'
                          aria-hidden='true'
                        />
                      </a>
                    </nav>
                  </div>
                </li>
              </ul>
            </section>
          </article>

          {/* RIGHT: Form card */}
          <section className='grid' aria-labelledby='contact-form-title'>
            <h3 id='contact-form-title' className='sr-only'>
              Booking Form
            </h3>
            <div className='grid bg-colour1/5 p-6 lg:p-8 rounded-2xl shadow-cardShadowBold'>
              <ContactForm />
            </div>
          </section>
        </div>
      </section>

      <VoteForMeNowCta />

      <section
        role='img'
        aria-label='Lady Cinder fire performance banner'
        className='py-12'
      >
        <img
          src={SissyBannerImage}
          alt='Lady Cinder — neon-gothic dominatrix and fire goddess training sissies'
          width='1200'
          height='400'
          loading='lazy'
          className='lg:mx-auto'
          decoding='async'
        />
      </section>

      <SocialMediaCtaComponent />
    </main>
  );
}

export default ContactPageMainContainer;
